import React from "react";
import PropTypes from "prop-types";
import {Grid, Typography} from "@mui/material";
import {makeStyles} from "tss-react/mui";

const usePageTitleStyles = makeStyles()((theme, {inline, detailView}) => ({
  title: {
    verticalAlign: inline ? "middle" : undefined,
    lineHeight: inline ? 1.75 : undefined,
    color: theme.palette.grey[theme.palette.mode === "dark" ? "200" : "900"],
    userSelect: "none",
    cursor: "default",
    ...(detailView && {
      marginTop: theme.spacing(0.5),
    }),
  },
}));

const PageTitle = ({children, count, id, inline, fontSize, detailView}) => {
  if (!children) {
    return null;
  }
  const {classes} = usePageTitleStyles({inline, detailView});

  return (
    <Grid item xs={inline ? false : 12}>
      <Typography variant="h5" className={classes.title} id={id} sx={fontSize}>
        {children}
        {count ? ` (${count})` : ""}
      </Typography>
    </Grid>
  );
};

PageTitle.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.string, PropTypes.node]).isRequired,
  count: PropTypes.number,
  id: PropTypes.string,
  inline: PropTypes.bool,
  fontSize: PropTypes.object,
  detailView: PropTypes.bool,
};

export default PageTitle;
